import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'static', // rewrite from 'relative' because it messes with initial popper-js positioning of `ToneOfVoiceMenu`
    },
    title: {},
    tovPicker: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      height: theme.spacing(6),
      border: theme.shape.borderGray60,
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadius,
      cursor: 'pointer',
      '&$disabled': {
        cursor: 'default',
        backgroundColor: COLORS.gray.gray80,
        color: COLORS.gray.gray50,

        '& $icon': {
          color: COLORS.gray.gray50,
        },
      },
      '&$active': {
        borderColor: COLORS.primary.default,
      },
      '&$error': {
        borderColor: COLORS.error.default,
      },
    },
    disabled: {},
    active: {},
    icon: {
      fontSize: theme.typography.pxToRem(16),
      marginLeft: 'auto',
    },
    error: {
      marginTop: theme.spacing(0.5),
    },
  }),
  { name: 'BlockToneOfVoice' }
);
